import { render, staticRenderFns } from "./Sitemap_en.vue?vue&type=template&id=48e3044e"
import script from "./Sitemap_en.vue?vue&type=script&lang=js"
export * from "./Sitemap_en.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports